import { type FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DragDropContext } from 'react-beautiful-dnd';
import DelayedDroppableWrapper from '@editor2/components/DelayedDroppableWrapper';

import { movePageGroup, movePage } from '@editor2/reducers/editor/editorSlice';
import { type RootState } from '@editor2/reducers/root';
import { contentBlock } from '@editor2/containers/ChapterPage/styles';
import PageGroup from './PageGroup';

interface Props {
	chapterId: string;
	courseId: number;
}

const PageGroupsList: FC<Props> = (props) => {
	const { chapterId, courseId } = props;

	const dispatch = useDispatch();
	const { chapters } = useSelector((state: RootState) => state.courses[courseId]);
	const pageGroups = chapters.entities[chapterId].page_groups;

	const onDragEnd = (result) => {
		const { source, destination, draggableId, type } = result;
		const { droppableId: sourceDroppableId } = source;
		const { droppableId: destinationDroppableId, index: destinationIndex } = destination;

		if (type === 'PageGroup') {
			dispatch(
				movePageGroup({
					sourceDroppableId,
					destinationDroppableId,
					destinationIndex,
					pageGroupId: draggableId,
					courseId
				})
			);
		}

		if (type === 'Page') {
			dispatch(
				movePage({
					sourceDroppableId,
					destinationDroppableId,
					destinationIndex,
					pageId: draggableId,
					courseId
				})
			);
		}
	};

	return (
		<div className={contentBlock}>
			<DragDropContext onDragEnd={onDragEnd}>
				<DelayedDroppableWrapper droppableId={chapterId} type="PageGroup">
					{(provided) => (
						<div ref={provided.innerRef} {...provided.droppableProps}>
							{pageGroups.map((pageGroupId, index) => (
								<PageGroup
									pageGroupId={pageGroupId}
									chapterId={chapterId}
									index={index}
									key={pageGroupId}
									courseId={courseId}
								/>
							))}
							{provided.placeholder}
						</div>
					)}
				</DelayedDroppableWrapper>
			</DragDropContext>
		</div>
	);
};

export default PageGroupsList;
